// 粉色主题配置 - 浪漫、温暖
export const pinkTheme = {
  colors: {
    'psychology-primary': '#e75480',      // 浅粉色 - 浪漫、温暖
    'psychology-secondary': '#8b5cf6',    // 紫色 - 神秘、优雅
    'psychology-accent': '#f59e0b',       // 温暖橙色 - 活力、关注
    'psychology-calm': '#fef6f9',         // 浅粉色 - 温柔、浪漫
    'psychology-warm': '#fdf2f8',         // 更浅粉色 - 温馨、柔和
    'psychology-success': '#059669',      // 深绿色 - 成功、积极
    'psychology-info': '#ec4899',         // 粉红色 - 补充色
    'psychology-warning': '#d97706',      // 警告橙 - 提醒色
  },
  name: 'pink',
  description: '浪漫粉色主题 - 温暖、感性'
}
